import * as React from 'react';
import Notifications from '../components/Notifications';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";

const Roles = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");
    if (permissions && !permissions.CanView) navigate("/error401");
    
    React.useEffect(() => { 
        GetColumnDefs("Roles", setColumns, setErrorMessage); 
        GetPermissions(["ViewRole", "NewRole", "EditRole", "DeleteRole", "ReportRole"], setPermissions)
    }, [])
    return (
        <div>
        <Notifications errorMessage={errorMessage}/>
        {columns && permissions && <DataGrid dataSource='apiv7/roles' columns={columns} permissions={permissions} keyField ="roleId" />}
        </div>       
    );

}

export default Roles;